export class PersonalizacaoGridModel{
    Id: number;
    EmpresaId: number;
    Tela: number = 0;
    UsuarioId: number;
    Array:string = "";
}
